import { render, staticRenderFns } from "./HeadCards.vue?vue&type=template&id=30384462&scoped=true&"
import script from "./HeadCards.vue?vue&type=script&lang=js&"
export * from "./HeadCards.vue?vue&type=script&lang=js&"
import style0 from "./HeadCards.vue?vue&type=style&index=0&id=30384462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30384462",
  null
  
)

export default component.exports